"use client";

import React from "react";
import { ArrowRight, Wheat, Leaf, Droplet, Bean } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const products = [{
  id: 1,
  name: "Artisanal Sourdough Focaccia",
  price: "$8.50",
  amazonLink: "/MenuPage"
}, {
  id: 2,
  name: "Ceremonial Grade Matcha",
  price: "$22.00",
  amazonLink: "/MarketPage"
}, {
  id: 3,
  name: "Imported Italian Olive Oil",
  price: "$34.99",
  amazonLink: "/MarketPage"
}, {
  id: 4,
  name: "House-Roasted Espresso Beans",
  price: "$19.00",
  amazonLink: "/MarketPage"
}];
const productVisuals: Record<number, {
  bg: string;
  icon: React.ReactNode;
}> = {
  1: {
    bg: "bg-accent/50 text-foreground",
    icon: <Wheat className="size-16 md:size-20 stroke-[1.5] transition-transform duration-500 group-hover:scale-110" aria-hidden="true" />
  },
  2: {
    bg: "bg-secondary/15 text-secondary",
    icon: <Leaf className="size-16 md:size-20 stroke-[1.5] transition-transform duration-500 group-hover:scale-110" aria-hidden="true" />
  },
  3: {
    bg: "bg-accent/30 text-foreground/80",
    icon: <Droplet className="size-16 md:size-20 stroke-[1.5] transition-transform duration-500 group-hover:scale-110" aria-hidden="true" />
  },
  4: {
    bg: "bg-muted text-foreground",
    icon: <Bean className="size-16 md:size-20 stroke-[1.5] transition-transform duration-500 group-hover:scale-110" aria-hidden="true" />
  }
};
export default function NewArrivals() {
  return <section data-section-id="256956" id="new-arrivals" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="font-default text-4xl md:text-5xl font-bold text-foreground mb-4">
            New Arrivals
          </h2>
          <p className="font-default text-muted-foreground text-lg max-w-2xl mx-auto">
            Fresh from our ovens and curated from European markets—discover the latest seasonal additions to M&M Café & Market.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((product, i) => {
          const visual = productVisuals[product.id];
          return <Card key={product.id} data-index={i} className="group flex flex-col overflow-hidden border-border shadow-sm hover:shadow-lg transition-all duration-500 bg-card rounded-xl">
                <div className={`aspect-square p-8 flex items-center justify-center border-b border-border/50 relative overflow-hidden ${visual?.bg ?? "bg-muted text-foreground"}`}>
                  {visual?.icon}
                </div>

                <CardContent className="p-6 flex-grow flex flex-col justify-between gap-4">
                  <div>
                    <h3 className="font-default font-semibold text-foreground text-xl leading-snug mb-2">
                      {product.name}
                    </h3>
                    <p className="font-default font-medium text-secondary text-lg">
                      {product.price}
                    </p>
                  </div>
                </CardContent>

                <CardFooter className="px-6 pb-6 pt-0">
                  <Button variant="link" className="text-primary hover:text-primary/80 p-0 h-auto font-default font-medium group/btn w-full justify-start" asChild>
                    <Link to={product.amazonLink}>
                      Explore Details
                      <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover/btn:translate-x-1" />
                    </Link>
                  </Button>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}